import _slicedToArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e from "react";

var r = "production" !== process.env.NODE_ENV ? Symbol("CONTEXT_LISTENERS") : Symbol(),
    t = function t(_t) {
  var o = e.createContext(_t, function () {
    return 0;
  });
  var c, n;
  return o[r] = new Set(), o.Provider = (c = o.Provider, n = o[r], e.memo(function (_ref) {
    var r = _ref.value,
        t = _ref.children;
    return "production" !== process.env.NODE_ENV ? e.useLayoutEffect(function () {
      n.forEach(function (e) {
        e(r);
      });
    }) : n.forEach(function (e) {
      e(r);
    }), e.createElement(c, {
      value: r
    }, t);
  })), delete o.Consumer, o;
},
    o = function o(t, _o) {
  var c = t[r];
  if ("production" !== process.env.NODE_ENV && !c) throw new Error("useContextSelector requires special context");

  var _e$useReducer = e.useReducer(function (e) {
    return e + 1;
  }, 0),
      _e$useReducer2 = _slicedToArray(_e$useReducer, 2),
      n = _e$useReducer2[1],
      u = e.useContext(t),
      s = _o(u),
      E = e.useRef(null);

  return e.useLayoutEffect(function () {
    E.current = {
      f: _o,
      v: u,
      s: s
    };
  }), e.useLayoutEffect(function () {
    var e = function e(_e) {
      try {
        if (E.current.v === _e || Object.is(E.current.s, E.current.f(_e))) return;
      } catch (e) {}

      n();
    };

    return c.add(e), function () {
      c["delete"](e);
    };
  }, [c]), s;
},
    c = function c(e) {
  return o(e, function (e) {
    return e;
  });
};

export { t as createContext, c as useContext, o as useContextSelector };